import { useState } from "react";
import PlusUpgradeModal from "./PlusUpgradeModal.jsx";
import { useI18n } from "../i18n.jsx";
import { usePlus } from "../plus/PlusProvider.jsx";

export default function PlusNudge({
  source = "plus-nudge",
  children = null,
  className = "",
  showWhenPlus = false
}) {
  const plus = usePlus();
  const { t } = useI18n();
  const [upgradeOpen, setUpgradeOpen] = useState(false);

  if (plus.isPlus && !showWhenPlus) return null;

  const classNames = ["plus-nudge", className].filter(Boolean).join(" ");
  const label = children || t("plus.defaultNudge");

  return (
    <>
    <button
      className={classNames}
      type="button"
      onClick={() => setUpgradeOpen(true)}
    >
      {label}
    </button>
    <PlusUpgradeModal open={upgradeOpen} onClose={() => setUpgradeOpen(false)} source={source} />
    </>
  );
}
